<template>
  <div class="horizontal-detail-input">
    <el-input
      v-model="content"
      @input="handleInput"
      :class="!valid && 'invalid'"
      :show-password="type === 'password'"
      :placeholder="placeholder"
      :maxlength="maxLength"
      show-word-limit
      :disabled="disabled"
      v-if="edit && (type === 'text' || type === 'password')"
    />
    <el-input
      type="textarea"
      :autosize="{ minRows: 2, maxRows: 6 }"
      v-model="content"
      :disabled="disabled"
      @input="handleInput"
      :class="!valid && 'invalid'"
      v-else-if="edit && type === 'textarea'"
    />
    <el-date-picker
      v-model="content"
      type="date"
      placeholder=""
      :value-format="dateFormat"
      :disabled="disabled"
      @change="handleInput"
      :class="!valid && 'invalid'"
      v-else-if="edit && type === 'datepicker'"
    />
    <el-date-picker
      v-model="content"
      type="datetime"
      placeholder=""
      :disabled="disabled"
      @change="handleInput"
      :class="!valid && 'invalid'"
      v-else-if="edit && type === 'datetime'"
    />
    <el-select
      v-model="content"
      clearable
      filterable
      placeholder=""
      :multiple="multiple"
      :disabled="disabled"
      @change="handleInput"
      :class="!valid && 'invalid'"
      v-else-if="edit && type === 'dropdown'"
    >
      <el-option
        v-for="item in options"
        :key="`select-${name}-${item.label || item}`"
        :label="item.label || item"
        :value="typeof item === 'object' ? item.value : item"
      >
      </el-option>
    </el-select>

   <el-time-picker
      v-model="content"
      format="HH:mm"
      value-format="HH:mm"
        :disabled="disabled"
      @change="handleInput"
      :class="!valid && 'invalid'"
      v-else-if="edit && type === 'time'"
    />
    <span class="horizontal-detail" v-else>
      {{ displayContent }}
    </span>
    <span class="error-label mt-1">
      {{ errorLabel }}
    </span>
  </div>
</template>
<script>
import { formatTime } from '../../utils/utils.js';

export default {
  name: 'HorizontalDetailInput',
  props: {
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
      validator: (value) => ['text', 'password', 'dropdown', 'datepicker', 'datetime', 'textarea', 'time'].includes(
        value,
      ),
    },
    field: {
      type: [String, Number, Date, Boolean, Array],
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: true,
    },
    errorLabel: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    maxLength: {
      type: [String, Number],
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dateFormat: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      content: this.field,
    };
  },
  computed: {
    displayContent() {
      if (this.type === 'dropdown' && typeof this.content === 'boolean') {
        return this.content ? this.$t('components.verticalDetail.yes')
          : this.$t('components.verticalDetail.no');
      }
      if (this.type === 'datepicker' || this.type === 'datetime') {
        return formatTime(this.content);
      }
      return this.content;
    },
  },
  watch: {
    field() {
      this.content = this.field;
    },
  },
  methods: {
    handleInput() {
      this.$emit('input', this.content);
    },
    onInput(value) {
      this.$emit('input', value);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
</style>
